import { createContext, type ReactNode, useContext } from 'react';

interface ViewContextType {
  loopId: number;
  viewId: number;
  isPublishedMode: boolean;
}

export const ViewContext = createContext<ViewContextType | undefined>(undefined);

interface ViewProviderProps {
  loopId?: number;
  viewId: number;
  isPublishedMode?: boolean;
  children: ReactNode;
}

export function ViewContextProvider({
  viewId,
  loopId,
  isPublishedMode = false,
  children,
}: ViewProviderProps) {
  return (
    <ViewContext.Provider value={{ viewId, loopId: loopId || 0, isPublishedMode }}>
      {children}
    </ViewContext.Provider>
  );
}

export function useViewContext() {
  const context = useContext(ViewContext);
  if (context === undefined) {
    throw new Error('useViewContext must be used within a ViewContextProvider');
  }
  return context;
}
